import { Component, Input, HostListener, HostBinding } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class ButtonComponent {
  @Input({ required: true }) btnBgColor: string;
  @Input({ required: false }) btnTextColor: string = '';
  @Input({ required: true }) btnHoverBgColor: string;
  @Input({ required: false }) btnHoverTextColor: string = '';
  @Input({ required: false }) label?: string;
  @Input({ required: false }) icon?: string;
  @Input({ required: false }) disable = false;
  @Input({ required: false }) isLoading = false;
  @Input({ required: false }) padding = '10px';

  isImageIcon(icon?: string): boolean {
    if (!icon) return false;
    return icon.includes('.') || icon.includes('/') || icon.startsWith('data:image');
  }

  @HostBinding('style.pointer-events') get pointerEvents() {
    return (this.disable || this.isLoading) ? 'none' : 'auto';
  }

  @HostBinding('style.opacity') get opacity() {
    return (this.disable || this.isLoading) ? '0.6' : '1';
  }

  @HostBinding('style.cursor') get cursor() {
    return (this.disable || this.isLoading) ? 'not-allowed' : 'pointer';
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    if (this.disable || this.isLoading) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
